var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnPlashkaDownloadpdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 912.2 93.7",
    style: {
      enableBackground: "new 0 0 912.2 93.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.5h25.2c24.3,0,42.4,18,42.4,42.4c0,24.3-18,42.4-42.4,42.4H0L0,4.5L0,4.5z M9.1,80.4h16.1c19.1,0,33-14.3,33-33.5 s-13.9-33.5-33-33.5H9.1V80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,2.7c24.3,0,44.2,19.8,44.2,44.2c0,24.3-19.8,44.2-44.2,44.2s-44-19.8-44-44.2S96.9,2.7,121.2,2.7z M121.4,82.2 c19.1,0,34.7-16.1,34.7-35.3c0-19.2-15.6-35.3-34.7-35.3c-19.2,0-34.8,16.1-34.8,35.3C86.5,66.1,102.1,82.2,121.4,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,4.5l-11.1,89.2l-34-54.5l-34,54.5L172.1,4.5h9.1l7.9,63l28.2-45.1l28.2,45.1l7.9-63L262.3,4.5L262.3,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,89.2H275V4.5h9.1L338.2,68V4.5h9.1v87.8l-63.2-74.2L284.1,89.2L284.1,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,89.2h-55.4V4.5h9.1v75.9h46.3V89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,2.7c24.3,0,44.2,19.8,44.2,44.2c0,24.3-19.8,44.2-44.2,44.2s-44-19.8-44-44.2S436.9,2.7,461.2,2.7z M461.4,82.2 c19.1,0,34.7-16.1,34.7-35.3c0-19.2-15.6-35.3-34.7-35.3c-19.2,0-34.8,16.1-34.8,35.3C426.5,66.1,442.1,82.2,461.4,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.2,70.4L515,89.2h-9.6L544.5,0l39,89.2h-9.6l-8.2-18.8H523.2z M544.5,21.8l-17.4,39.8h34.7L544.5,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.1,4.5h25.2c24.3,0,42.4,18,42.4,42.4c0,24.3-18,42.4-42.4,42.4h-25.2V4.5z M602.2,80.4h16.1c19.1,0,33-14.3,33-33.5 s-13.9-33.5-33-33.5h-16.1V80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.1,53.1v36.1H703V4.5h38.8c12.2,0,22,9.8,22,22c0,10.9-8,20.1-18.5,21.7L712.1,53.1z M712.1,44.2l30.1-4.5 c7.1-1.1,12.3-5.6,12.3-13.2c0-7.1-5.7-13.2-12.7-13.2H712L712.1,44.2L712.1,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776,4.5h25.2c24.3,0,42.4,18,42.4,42.4c0,24.3-18,42.4-42.4,42.4H776V4.5L776,4.5z M785,80.4h16.1c19.1,0,33-14.3,33-33.5 s-13.9-33.5-33-33.5H785V80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.4,45.9v8.8h-41.5v34.5h-9.1V4.5h55.4v8.8h-46.3v32.5h41.5V45.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnPlashkaDownloadpdf);
export default __webpack_public_path__ + "static/media/EN_PLASHKA_download pdf.a19899bdf1f96a1626577986bcb9e984.svg";
export { ForwardRef as ReactComponent };